export enum ExpenseReportView {
  employee = "Employee",
  manager = "Manager",
}

export const uniqueCountyCodes = (countryCodes: string[]): string[] => {
  if (!countryCodes) return [];

  const filteredCountryCode: string[] = [];
  const countriesRes: Record<string, string> = {};

  countryCodes.forEach((code) => {
    if (code) {
      const isCountryAlreadyStored = countriesRes[code];

      if (!isCountryAlreadyStored) {
        countriesRes[code] = code;

        filteredCountryCode.push(code);
      }
    }
  });

  return filteredCountryCode;
};

export const fetchFlagImagesAsBase64 = async (countryCodes: string[]) => {
  const base64Images: Record<string, string> = {};

  await Promise.all(
    countryCodes.map(async (countryCode) => {
      const response = await fetch(
        `https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.5/flags/4x3/${countryCode.toLowerCase()}.svg`
      );
      const svgText = await response.text();
      const modifiedSvg = svgText.replace(/<svg /, '<svg width="30" height="30" ');
      const blob = new Blob([modifiedSvg], { type: "image/svg+xml" });
      const base64String = await convertBlobToBase64(blob);
      base64Images[countryCode] = base64String;
    })
  );

  return base64Images;
};

const convertBlobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
